/**
 * API Service pour les profils de détection d'entrées
 * 
 * Ces profils configurent comment les entrées (mots-clés) sont détectées
 * automatiquement dans le texte lors de l'édition de notes.
 */
import axios, { AxiosRequestConfig } from 'axios';
import { Profile, CreateProfileRequest, UpdateProfileRequest } from '../../types/api';

const baseUrl = '/api/profiles';

// Fonction pour créer la configuration avec authentification
const createAuthConfig = (token?: string): AxiosRequestConfig => {
  if (!token) return {};
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'accesstoken': token,
      'Content-Type': 'application/json'
    }
  };
};

// Variable pour stocker le token actuel (sera mis à jour par le slice)
let currentToken: string | null = null;

// Fonction pour définir le token (appelée par le slice avant les requêtes)
export const setAuthToken = (token: string | null) => {
  currentToken = token;
};

export const detectionProfileService = {
  /**
   * Récupère tous les profils de détection de l'utilisateur
   */
  getAll: async (): Promise<Profile[]> => {
    console.log('🔍 detectionProfileService.getAll - token présent:', !!currentToken);
    const response = await axios.get(baseUrl, createAuthConfig(currentToken || undefined));
    return response.data.data;
  },

  /**
   * Récupère un profil de détection par son ID
   */
  getById: async (id: string): Promise<Profile> => {
    const response = await axios.get(`${baseUrl}/${id}`, createAuthConfig(currentToken || undefined));
    return response.data.data;
  },

  /**
   * Crée un nouveau profil de détection
   */
  create: async (data: CreateProfileRequest): Promise<Profile> => {
    console.log('📡 API Call: POST /api/profiles', data);
    const response = await axios.post(baseUrl, data, createAuthConfig(currentToken || undefined));
    console.log('📥 API Response:', response.data);
    return response.data.data;
  },

  /**
   * Met à jour un profil de détection existant
   */
  update: async (id: string, data: UpdateProfileRequest): Promise<Profile> => {
    const response = await axios.put(`${baseUrl}/${id}`, data, createAuthConfig(currentToken || undefined));
    return response.data.data;
  },

  /**
   * Supprime un profil de détection
   */
  delete: async (id: string): Promise<void> => {
    await axios.delete(`${baseUrl}/${id}`, createAuthConfig(currentToken || undefined));
  }
};

// Export de compatibilité pour l'ancien nom
export const profileService = detectionProfileService;
